import _ from 'lodash';

export class FileFunctions {

    static convertJsonObjectToCleanFileStructure = (contents, parent) => {
        const result = this.#convert(contents, parent);
        parent.contents = result;
        return this.#convertToCleanItem({ isFolder: true, isFile: false, contents: parent.contents, path: parent.path ?? '/', name: parent.name, parent: parent.parent });
    };

    static #convert = (contents, parent) => {

        if (contents && !Array.isArray(contents)) {
            return this.#convert(_.filter(Object.entries(contents), p => p[0] !== '$id'), parent);
        }
        const result = _.map(contents, c => {
            if (c && Array.isArray(c)) {

                const directoryObject = c[1];

                if ((directoryObject.objectType && directoryObject.objectType === 'folder') || directoryObject.isFolder) {
                    return { contents: this.#convert(directoryObject.contents, directoryObject).map(c => this.#convertToCleanItem(c)), isFolder: true, isFile: false, isDeleted: false, name: directoryObject.name, path: directoryObject.path, parent: this.#convertToCleanItem(parent) };
                }
                else if (((directoryObject.objectType && directoryObject.objectType === 'file') || directoryObject.isFile)) {
                    return {
                        isFile: true,
                        isFolder: false,
                        isDeleted: directoryObject.deleted, // TODO: For some reason this comes out as undefined so I cant use it at the moment.
                        deletedDate: directoryObject.deletedDate,
                        versionId: directoryObject.versionId,
                        eTag: directoryObject.eTag,
                        name: directoryObject.name,
                        size: directoryObject.size,
                        path: directoryObject.path,
                        contentType: directoryObject.contentType,
                        created: directoryObject.created,
                        modified: directoryObject.modified,
                        downloadUri: directoryObject.downloadUri,
                        containerName: directoryObject.containerName,
                        parent: this.#convertToCleanItem(parent),
                        previousVersions: directoryObject.previousVersions ? directoryObject.previousVersions.map(pv => this.#convertToCleanItem(pv)) : []
                    }
                }
            }
        });

        return result;

    };

    static #convertToCleanItem = (directoryObject) => {

        if ((directoryObject.objectType && directoryObject.objectType === 'folder') || directoryObject.isFolder) {
            return { isFolder: true, isFile: false, isDeleted: false, contents: directoryObject.contents, path: directoryObject.parent ? directoryObject.path : '/', name: directoryObject.name, parent: directoryObject.parent };
        }
        else if (((directoryObject.objectType && directoryObject.objectType === 'file') || directoryObject.isFile)) {
            return {
                isFile: true,
                isFolder: false,
                isDeleted: directoryObject.deleted, // TODO: For some reason this comes out as undefined so I cant use it at the moment.
                deletedDate: directoryObject.deletedDate,
                versionId: directoryObject.versionId,
                eTag: directoryObject.eTag,
                name: directoryObject.name,
                size: directoryObject.size,
                path: directoryObject.path,
                contentType: directoryObject.contentType,
                parent: this.#convertToCleanItem(directoryObject.parent),
                created: directoryObject.created,
                modified: directoryObject.modified,
                downloadUri: directoryObject.downloadUri,
                containerName: directoryObject.containerName,
                previousVersions: directoryObject.previousVersions
            }
        }
    };

    static cleanBlobPath = path => path.replace(/\//g, "\\").replace(/^\\+|\\+$/g, "");
}